import { createRootRoute, Outlet } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'
import { MapProvider } from 'react-map-gl/maplibre'

export const Route = createRootRoute({
  component: RootComponent,
})

function RootComponent() {
  return (
    <MapProvider>
      <Outlet />
      <TanStackRouterDevtools position="bottom-right" />
    </MapProvider>
  )
}
